import qs from 'qs'

// 获取请求参数
export function GetUrlParams () {
    const index = location.search.indexOf('?')
    if (index === -1) return {}
    const params = location.search.slice(index + 1)
    return qs.parse(params)
}
